/* eslint-disable camelcase */
import { includes, without } from 'lodash';
import { Component } from 'react';

import { displayNotif } from 'hb-react/shared/helpers/notifications';

import * as NotificationTemplates from './BookmarkNotificationTemplates';

class BookmarkerApp extends Component {
  constructor(props) {
    super(props);
    const { bookmarkable, bookmarkable_type } = props;

    const isBookmarked = includes(this.bookmarkable_ids(), bookmarkable.id);

    this.state = {
      isBookmarked,
      waitingServerResponse: false,
      bookmarkable_id: bookmarkable.id,
      bookmarkable_type,
    };
  }

  // SERVER INTERACTION

  destroyBookmark = () => {
    const path = Routes.user_bookmarks_path(AlumniConnect.currentUser.id);
    const { bookmarkable, bookmarkable_type } = this.props;
    const data = {
      bookmarkable_id: bookmarkable.id,
      bookmarkable_type,
    };

    $.ajax({
      url: path,
      type: 'DELETE',
      data,
    }).done(() => {
      this.setState({
        isBookmarked: false,
        waitingServerResponse: false,
      });
      this.removeBookmarkFromCurrentUser();
      this.props.onChange && this.props.onChange(this.state);
    });
    this.setState({ waitingServerResponse: true });
  };

  createBookmark = () => {
    const path = Routes.user_bookmarks_path(AlumniConnect.currentUser.id);
    const { bookmarkable, bookmarkable_type } = this.props;
    const data = {
      bookmarkable_id: bookmarkable.id,
      bookmarkable_type,
    };

    $.ajax({
      url: path,
      type: 'POST',
      data,
    }).done(() => {
      this.setState({
        isBookmarked: true,
        waitingServerResponse: false,
      });
      this.saveBookmarkToCurrentUser();
      this.notifySuccess();
      this.props.onChange && this.props.onChange(this.state);
    });
    this.setState({ waitingServerResponse: true });
  };

  // GlOBAL STATE
  bookmarkable_ids = (newValue) => {
    if (newValue) {
      return AlumniConnect.currentUser.set(
        `bookmarked_${this.props.bookmarkable_type.toLowerCase()}_ids`,
        newValue,
      );
    }

    return AlumniConnect.currentUser.get(
      `bookmarked_${this.props.bookmarkable_type.toLowerCase()}_ids`,
    );
  };

  saveBookmarkToCurrentUser = () => {
    const ids = this.bookmarkable_ids();

    ids.unshift(this.props.bookmarkable.id);
    this.bookmarkable_ids(ids);
  };

  removeBookmarkFromCurrentUser = () => {
    let ids = this.bookmarkable_ids();

    ids = without(ids, this.props.bookmarkable.id);
    this.bookmarkable_ids(ids);
  };

  notifySuccess = () => {
    const { bookmarkable, bookmarkable_type } = this.props;
    let text = null;

    switch (bookmarkable_type) {
      case 'User': {
        text = NotificationTemplates.userTemplate({
          bookmarkable,
        });
        break;
      }

      default:
    }

    if (text) {
      displayNotif('success', text);
    }
  };

  // HANDLERS

  handleClick = () => {
    if (this.state.isBookmarked) {
      this.destroyBookmark();
    } else {
      this.createBookmark();
    }
  };

  // RENDERERS

  renderContent = () => {
    const networkConfig = AlumniConnect.currentNetwork.get('network_config');
    const bookmarkIcon = this.state.isBookmarked
      ? 'icon-star-full customizable-button--color custom-color-button-primary'
      : 'icon-star-empty color-gray-smooth';

    if (this.state.waitingServerResponse) {
      return (
        <span className="spin-animation inline-block">
          <i className="icon-spinner9 color-gray" />
        </span>
      );
    }
    const activeKey = this.state.isBookmarked ? 'added_to' : 'add_to';
    const title = I18n.t(`web.bookmarks.tooltip.${activeKey}`, {
      user_bookmarks_label: networkConfig.user_bookmarks_label,
    });

    return (
      <a onClick={this.handleClick} title={title}>
        <i className={`${bookmarkIcon} icon-star-empty`} />
      </a>
    );
  };

  render() {
    return <div className="bookmarker__wrapper">{this.renderContent()}</div>;
  }
}

export default BookmarkerApp;
